/** Runs a Web Storage call; undefined where storage is refused outright (Safari's private mode,
 *  a storage-blocked iframe), so a lost value never becomes a blank page. */
export const safeStorage = <T>(fn: () => T): T | undefined => {
    try {
        return fn();
    } catch {
        return undefined;
    }
};
